// src/orgs.js
export const ORGS = [
  { id: "org_1EAAJfZoWcbBs75Q", name: "fund-xeia", label: "XEIA Investment Fund" },
  { id: "org_2iaC2w0aWeBT1O9S", name: "fund-atf", label: "Alfredo's Test Fund" },
  { id: "org_ifS2NgPMAJHvLly7", name: "fund-hcre", label: "HCRE 1177, LLC" },
  { id: "org_oaPf9R3sgQk5825x", name: "fund-kasba", label: "Kasba Investment Fund" },
];

